export const createBase64FromBlob = async (blob: Blob) =>
	new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			const result = reader.result as string;
			const base64 = result.split(',')[1];
			resolve(base64);
		};
		reader.onerror = () => reject(new Error('Failed to convert to base64'));
		reader.readAsDataURL(blob);
	});
